import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api, fmtTid, type Charger, type Me } from '../lib/api.ts';
import { Badge } from '../components/ui.tsx';

export default function Chargers({ me: _me }: { me: Me }) {
  const chargersQuery = useQuery<Charger[]>({
    queryKey: ['chargers'],
    queryFn: () => api.get('/chargers'),
  });

  const chargers = chargersQuery.data ?? [];

  return (
    <div>
      <h1 className="mb-3 text-xl font-bold text-slate-800">Ladere</h1>
      <div className="overflow-x-auto rounded-xl bg-white ring-1 ring-slate-200">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-slate-200 text-left text-xs uppercase tracking-wide text-slate-400">
              <th className="px-4 py-3">Navn</th>
              <th className="px-4 py-3">Anlegg</th>
              <th className="px-4 py-3">Eier</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Sist oppdatert</th>
              <th className="px-4 py-3">Aktiv</th>
            </tr>
          </thead>
          <tbody>
            {chargers.map((c) => (
              <tr key={c.id} className="border-b border-slate-100 last:border-0 hover:bg-slate-50">
                <td className="px-4 py-3">
                  <Link to={`/ladere/${c.id}`} className="font-medium text-blue-700 hover:underline">
                    {c.navn}
                  </Link>
                </td>
                <td className="px-4 py-3 text-slate-600">
                  {c.anleggNavn} <span className="text-xs text-slate-400">({c.prisomrade})</span>
                </td>
                <td className="px-4 py-3 text-slate-600">{c.eierNavn ?? '–'}</td>
                <td className="px-4 py-3">
                  <Badge state={c.sistState} />
                </td>
                <td className="px-4 py-3 text-slate-500">{fmtTid(c.sistStateTs)}</td>
                <td className="px-4 py-3">{c.aktiv ? 'Ja' : 'Nei'}</td>
              </tr>
            ))}
            {!chargers.length && !chargersQuery.isLoading && (
              <tr>
                <td colSpan={6} className="px-4 py-6 text-center text-slate-500">
                  Ingen ladere. Legg til en leverandørkonto under Register.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
